import { Response } from '../../models/response';
import { api as axiosApi } from '../../utils/axios';
import globalErrorUtils from '../globalErrorUtils';

const post = <Type>(path: string, params?: any): Promise<Response<Type>> => {
    return axiosApi
        .post(path, params)
        .then((resp: any) => {
            return Response.createSuccessful<Type>(resp.data, resp.status);
        })
        .catch((error: any) => {
            globalErrorUtils.handleError(error);
            // handleError(error);
            throw error;
        });
};

const get = <Type>(path: string, params?: any): Promise<Response<Type>> => {
    return axiosApi
        .get(path, { params })
        .then((resp: any) => {
            return Response.createSuccessful<Type>(resp.data, resp.status);
        })
        .catch((error: any) => {
            globalErrorUtils.handleError(error);
            throw error;
        });
};

const put = <Type>(path: string, params?: any): Promise<Response<Type>> => {
    return axiosApi
        .put(path, params)
        .then((resp: any) => {
            return Response.createSuccessful<Type>(resp.data, resp.status);
        })
        .catch((error: any) => {
            globalErrorUtils.handleError(error);
            throw error;
        });
};

const del = <Type>(path: string, params?: any): Promise<Response<Type>> => {
    return axiosApi
        .delete(path, { data: params })
        .then((resp: any) => {
            return Response.createSuccessful<Type>(resp.data, resp.status);
        })
        .catch((error: any) => {
            globalErrorUtils.handleError(error);
            throw error;
        });
};

const httpApi = { post, get, put, del };

export default httpApi;
